import { useEffect, useState } from 'react';
import { toZonedTime } from 'date-fns-tz';

/**
 * Returns "now" as a local-wall-clock Date in the given IANA timezone.
 *
 * The returned Date's UTC getters (getUTCHours etc.) do NOT represent UTC —
 * they represent the wall-clock time in `timezone`. This is the shape
 * `date-fns` functions like `startOfDay`, `subDays`, `format` need in order
 * to operate on calendar semantics in the target timezone.
 *
 * Recomputes on a 60s tick so presets reflect the real "today" if the
 * picker is opened across midnight in the location's TZ.
 */
export function useLocationNow(timezone: string | undefined): Date {
  const [now, setNow] = useState<Date>(() => toZonedTime(new Date(), timezone ?? 'UTC'));

  useEffect(() => {
    setNow(toZonedTime(new Date(), timezone ?? 'UTC'));
    const id = window.setInterval(() => {
      setNow(toZonedTime(new Date(), timezone ?? 'UTC'));
    }, 60_000);
    return () => window.clearInterval(id);
  }, [timezone]);

  return now;
}
